"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileDropZone = void 0;
class FileDropZone {
    constructor(element) {
        this.element = element;
        this.createFileInput();
        this.setupEventListeners();
    }
    createFileInput() {
        // Create hidden file input
        this.fileInput = document.createElement('input');
        this.fileInput.type = 'file';
        this.fileInput.accept = '.bcf,.bcfzip';
        this.fileInput.style.display = 'none';
        document.body.appendChild(this.fileInput);
        // Handle file selection
        this.fileInput.addEventListener('change', (e) => {
            const target = e.target;
            if (target.files && target.files.length > 0) {
                this.handleFile(target.files[0]);
            }
        });
    }
    setupEventListeners() {
        // Click to browse
        this.element.addEventListener('click', () => {
            this.fileInput.click();
        });
        // Drag and drop events
        this.element.addEventListener('dragover', (e) => {
            e.preventDefault();
            this.element.classList.add('drag-over');
        });
        this.element.addEventListener('dragleave', () => {
            this.element.classList.remove('drag-over');
        });
        this.element.addEventListener('drop', (e) => {
            var _a;
            e.preventDefault();
            this.element.classList.remove('drag-over');
            const files = (_a = e.dataTransfer) === null || _a === void 0 ? void 0 : _a.files;
            if (files && files.length > 0) {
                this.handleFile(files[0]);
            }
        });
    }
    handleFile(file) {
        if (this.onFileDropped) {
            this.onFileDropped(file);
        }
    }
}
exports.FileDropZone = FileDropZone;
